<template>
  <!--合同结算-->
  <div class="cooperation-accounts-detail-container">
    <div class="accounts-list-content">
      <van-list
        :offset="30"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, index) in list" :key="index">
          <template>
            <accounts-list :item="item"></accounts-list>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import accountsList from './components/cooperation-accounts-detail-list';
import { Sticky, List, PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-accounts-detail',

  data() {
    return {
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      contractguid: ''
    };
  },
  mounted() {},
  created() {
    let { contractguid } = this.$route.query;
    let { id } = getUrlParams();
    if (!contractguid) {
      contractguid = id;
    }
    let params = {
      contractguid: contractguid,
      current: this.current,
      size: this.size
    };
    this.contractguid = contractguid;
    this._getContractListByid(params);
  },
  components: {
    accountsList,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getContractListByid(params) {
      let { current, contractguid, size } = this;
      params = { current, size, contractguid, ...params };
      this.$api.getContractListByid(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    onLoad() {
      this.current++;
      this._getContractListByid({});
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-accounts-detail-container {
  position: relative;
  z-index: 9;
  .accounts-list-content {
    margin-top: 10px;
    // background: white;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
  }
}
</style>
